import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reduxSlices/authSlice";
import salesRegistrationReducer from "./reduxSlices/salePersonFormSlice";
import audioUploadReducer from "./reduxSlices/audioUploadSlice";
import profileReducer from "./reduxSlices/userProfileSlice"
import ordersReducer from "./reduxSlices/ordersSlice"
import adminReducer from "./reduxSlices/adminSlice"
import collageReducer from "./reduxSlices/collageSlice"
import chatReducer from "./reduxSlices/chatSlice"
import quotationReducer from "./reduxSlices/quotationSlice"

const store = configureStore({
  reducer: {
    auth: authReducer,
    saleRegistartion: salesRegistrationReducer,
    audioUpload: audioUploadReducer,
    profile: profileReducer,
    orders: ordersReducer,
    admin: adminReducer,
    collage: collageReducer,
    chat: chatReducer,
    quotation: quotationReducer,
  },
});

export default store